import definition from './remote.service';

/**
 * RemoteConfigService settings
 * @type {{name: string, definition: RemoteConfigService}}
 */
export default {
    name: 'RemoteConfigService',
    definition
};



// WEBPACK FOOTER //
// ./app/services/config/remote/index.js